import PageHeader from '../components/molecules/PageHeader';
import useParents from '../hooks/parents.hook';
import { useNavigate } from 'react-router-dom';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { TextField } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Parents = () => {
  const {
    data,
    isLoading,
    searchString,
    setSearchString,
    checkSearchOnKeyDown,
  } = useParents();

  const navigate = useNavigate();

  const SearchBox = () => {
    return (
      <>
        <input
          className='rounded-md border-2 border-primary-300 px-4 py-2'
          type='text'
          aria-label='Parent Search'
          name='parent-search'
          onKeyUp={checkSearchOnKeyDown}
          id='parentSearchField'
          placeholder='Parent Search'
          data-cy='parent-search-input'
        />
      </>
    );
  };
  return (
    <>
      <PageHeader
        RightSideComponent={SearchBox}
        setSearchString={setSearchString}
      >
        Parents
      </PageHeader>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Parent Name</TableCell>
            <TableCell>Mobile</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>ID</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data?.map((parentInfo, index) => {
            return (
              <TableRow
                className='row'
                key={index}
                onClick={() =>
                  navigate(`/manage/parents/edit/${parentInfo.parent_id}`)
                }
              >
                <TableCell component='th' scope='row'>
                  {parentInfo.parent_name || '--'}
                </TableCell>
                <TableCell>{parentInfo.parent_mobile || '--'}</TableCell>
                <TableCell>{parentInfo.parent_email || '--'}</TableCell>
                <TableCell>
                  {parentInfo.parent_identity_number || '--'}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>

      <ToastContainer />

      <Backdrop
        sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
        open={!!isLoading}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
    </>
  );
};

export default Parents;
